import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Shared UI Library Components
import { CustomIcon, EIconName } from '@ppmcore/seven-ppm-core-shared-components-react';

// Components
import { AddCounsellorModal } from '../../../../modals/add-counsellor-modal/add-counsellor-modal';

// Models
import { ICounsellor } from '../../../../interfaces/counsellors.interfaces';

// Store
import { getUserState } from '../../../../store/user/user.selectors';

// Styles
import './business-block.scss';

type TBusinessAction = 'add-counsellor' | null;

type TBusinessBlockProps = {};

export const BusinessBlock: FC<TBusinessBlockProps> = (
  {}: TBusinessBlockProps
) => {
  const [addModalOpen, setAddModalOpen] = useState<boolean>(false);
  const [hideBlock, setHideBlock] = useState<boolean>(false);

  const navigate = useNavigate();
  const { user } = useSelector(getUserState);

  const stepsList: Array<{ label: string, highPriority: boolean, link: string, action: TBusinessAction }> = [
    { label: 'Business Information', highPriority: false, link: '/business-profile', action: null },
    { label: 'Consultations Settings', highPriority: false, link: '/business-profile/consultations-settings', action: null },
    {
      label: 'Consultant Attributes',
      highPriority: true,
      link: '/business-profile/counsellor-attributes',
      action: null
    },
    { label: 'Consultants Management', highPriority: true, link: '/counsellors', action: 'add-counsellor' },
    { label: 'Permission Settings', highPriority: false, link: '/business-profile/permission-settings', action: null },
  ];

  const toggleAddCounsellorModal = (): void => {
    setAddModalOpen(prevState => !prevState);
  }

  const toggleHideBlockState = (): void => {
    setHideBlock(!hideBlock);
  }

  const onCounsellorCreatedHandler = (counsellor: ICounsellor): void => {
    navigate(`/counsellors/${ counsellor.id ?? user?.id }`);
  }

  const navigateToLink = (link: string, action: TBusinessAction): void => {
    if (action === 'add-counsellor') {
      toggleAddCounsellorModal();
      return;
    }
    navigate(link);
  }

  return (
    <div className="business-block">

      <AddCounsellorModal
        open={ addModalOpen }
        onCancel={ toggleAddCounsellorModal }
        onSubmit={ onCounsellorCreatedHandler }
      />

      <div className="business-block--header">
        <div className="header-title">
          Set Up your Business!
        </div>
        <div className={ `header-action header-action--${ hideBlock ? 'open' : 'hide' }` }
             onClick={ toggleHideBlockState }>
          { hideBlock ? 'Show' : 'Hide' } <CustomIcon size={ 'size-md' } name={ EIconName.ArrowDown }/>
        </div>
      </div>
      <div className="business-block--description" hidden={ hideBlock }>
        <p className="description-paragraph">
          Customize your app and start earning!
        </p>
        <p className="description-paragraph">
          For a complete and informative user journey for both  Consultants and Сlients, thorough configuration of your business in all settings sections is crucial.
        </p>
        <p className="description-paragraph">
          Navigate through the sections in the order listed below.
        </p>
      </div>
      <div className="business-block--body" hidden={ hideBlock }>
        {
          stepsList.map(({ label, link, action, highPriority }, idx) =>
            <div key={ idx } className="body-item" onClick={ () => navigateToLink(link, action) }>
              <div className="body-item--order">
                { idx + 1 }
              </div>
              <div className="body-item--label">
                { label }
              </div>
              { highPriority && <div className="body-item--priority">
                high priority
              </div> }
              <div className="body-item--arrow">
                <CustomIcon name={ EIconName.ArrowUpwardFill }/>
              </div>
            </div>)
        }
      </div>
    </div>
  );
}
